














































import Vue, { PropOptions } from 'vue'
import HeaderSection from './HeaderSection.vue'
import { PRINTING_METHOD } from '@/search/const'
import { PrintingMethodsCount } from '@/search/types'
import FilterItem from './FilterItem.vue'

export default Vue.extend({
  components: {
    HeaderSection,
    FilterItem
  },
  props: {
    methodsCount: {
      type: Object,
      required: true
    } as PropOptions<PrintingMethodsCount>,
    printingMethods: {
      type: Array,
      required: true
    } as PropOptions<string[]>
  },
  data(): {
    toggleSection: boolean
    printingMethodItems: Array<{ [key: string]: string }>
    printMethods: Array<string>
  } {
    return {
      toggleSection: true,
      printingMethodItems: PRINTING_METHOD,
      printMethods: []
    }
  },
  computed: {
  },
  watch: {
    printingMethods: {
      immediate: true,
      handler(values: string[]) {
        this.printMethods = []
        this.printingMethodItems.forEach(i => {
          if (values.includes(i.value)) {
            this.printMethods.push(i.value)
          }
        })
      }
    }
  },
  methods: {
    printingMethodCount(type: string): number {
      return (this.methodsCount as any)[type]
    },
    toggleSectionHandler(value: { [key: string]: boolean }) {
      this.toggleSection = value.toggle
    },
    searchPrintMethod() {
      this.$emit('onSearchPrintMethod', this.printMethods)
    }
  }
})
